// export const blue = {
//   100: "#DAECFF",
//   200: "#b6daff",
//   300: "#66B2FF",
//   400: "#3399FF",
//   500: "#007FFF",
//   600: "#0072E5",
//   700: "#0059B2",
//   900: "#003A75",
// };

export const blue = {
  100: "#D4E7F7", // 기존보다 밝은 톤
  200: "#A6D2F1", // 좀 더 밝은 파스텔 톤
  300: "#7BBDEA", // 기존보다 밝은 하늘색 느낌
  400: "#5BAFEC", // #59A9EB에 가까운 중간색
  500: "#349aee", // 메인 컬러
  600: "#4A92D1", // 메인보다 조금 어두운 색
  700: "#3C7AB5", // 더 어두운 색
  900: "#275281", // 가장 어두운 색상
};

export const grey = {
  50: "#F3F6F9",
  100: "#E5EAF2",
  200: "#DAE2ED",
  300: "#C7D0DD",
  400: "#B0B8C4",
  500: "#9DA8B7",
  600: "#6B7A90",
  700: "#434D5B",
  800: "#303740",
  900: "#1C2025",
};
